/** 统一处理 localStorage */

import type { SystemVersionDTO } from "@repo/codegen/teashop-base-api"
import type { BusinessProductCardViewMode, BusinessTableCardDensity, ThemeDensityName, ThemeDensityScale, ThemeFontName, ThemeFontSize, ThemeFontWeight, ThemePreference, ThemeProfileName, ThemeSurfaceEffectName } from "@/hooks/useTheme"
import CacheKey from "@/constants/cacheKey"

export const getSidebarStatus = () => {
  // 关闭用户选择折叠侧边栏功能
  // return localStorage.getItem(CacheKey.SIDEBAR_STATUS)
  return "closed"
}
export const setSidebarStatus = (sidebarStatus: "opened" | "closed") => {
  localStorage.setItem(CacheKey.SIDEBAR_STATUS, sidebarStatus)
}

export const getActiveThemeName = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_NAME)
}
export const setActiveThemeName = (themeName: ThemePreference) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_NAME, themeName)
}

export const getActiveThemeColor = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_COLOR)
}

export const setActiveThemeColor = (themeColor: string) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_COLOR, themeColor)
}

export const getActiveThemeFont = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_FONT)
}

export const setActiveThemeFont = (themeFont: ThemeFontName) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_FONT, themeFont)
}

export const getActiveThemeFontSize = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_FONT_SIZE)
}

export const setActiveThemeFontSize = (themeFontSize: ThemeFontSize) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_FONT_SIZE, String(themeFontSize))
}

export const getActiveThemeFontWeight = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_FONT_WEIGHT)
}

export const setActiveThemeFontWeight = (themeFontWeight: ThemeFontWeight) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_FONT_WEIGHT, String(themeFontWeight))
}

export const getActiveThemeDensity = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_DENSITY)
}

export const setActiveThemeDensity = (themeDensity: ThemeDensityName) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_DENSITY, themeDensity)
}

export const getActiveThemeDensityScale = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_DENSITY_SCALE)
}

export const setActiveThemeDensityScale = (themeDensityScale: ThemeDensityScale) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_DENSITY_SCALE, String(themeDensityScale))
}

export const getActiveThemeSurfaceEffect = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_SURFACE_EFFECT)
}

export const setActiveThemeSurfaceEffect = (themeSurfaceEffect: ThemeSurfaceEffectName) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_SURFACE_EFFECT, themeSurfaceEffect)
}

export const getActiveThemeProfile = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_PROFILE)
}

export const setActiveThemeProfile = (themeProfile: ThemeProfileName) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_PROFILE, themeProfile)
}

export const getActiveThemeBrightness = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_BRIGHTNESS)
}

export const setActiveThemeBrightness = (value: number) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_BRIGHTNESS, String(value))
}

export const getActiveThemeBrightnessEnabled = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_BRIGHTNESS_ENABLED)
}

export const setActiveThemeBrightnessEnabled = (value: boolean) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_BRIGHTNESS_ENABLED, value.toString())
}

export const getActiveThemePerformanceMode = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_PERFORMANCE_MODE)
}

export const setActiveThemePerformanceMode = (value: boolean) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_PERFORMANCE_MODE, value.toString())
}

export const getActiveThemeAdvancedControls = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_ADVANCED_CONTROLS)
}

export const setActiveThemeAdvancedControls = (value: boolean) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_ADVANCED_CONTROLS, value.toString())
}

export const getBusinessTableCardDensity = () => {
  return localStorage.getItem(CacheKey.BUSINESS_TABLE_CARD_DENSITY)
}

export const setBusinessTableCardDensity = (value: BusinessTableCardDensity) => {
  localStorage.setItem(CacheKey.BUSINESS_TABLE_CARD_DENSITY, value)
}

export const getBusinessTableCardDensityLinked = () => {
  return localStorage.getItem(CacheKey.BUSINESS_TABLE_CARD_DENSITY_LINKED)
}

export const setBusinessTableCardDensityLinked = (value: boolean) => {
  localStorage.setItem(CacheKey.BUSINESS_TABLE_CARD_DENSITY_LINKED, value.toString())
}

export const getBusinessProductCardViewMode = () => {
  return localStorage.getItem(CacheKey.BUSINESS_PRODUCT_CARD_VIEW_MODE)
}

export const setBusinessProductCardViewMode = (value: BusinessProductCardViewMode) => {
  localStorage.setItem(CacheKey.BUSINESS_PRODUCT_CARD_VIEW_MODE, value)
}

export const getBusinessProductCardDensityLinked = () => {
  return localStorage.getItem(CacheKey.BUSINESS_PRODUCT_CARD_DENSITY_LINKED)
}

export const setBusinessProductCardDensityLinked = (value: boolean) => {
  localStorage.setItem(CacheKey.BUSINESS_PRODUCT_CARD_DENSITY_LINKED, value.toString())
}

export const getIsPrintRechargeBillLocalStorage = () => {
  return localStorage.getItem(CacheKey.IS_PRINT_RECHARGE_BILL)
}
export const setIsPrintRechargeBillLocalStorage = (value: boolean) => {
  localStorage.setItem(CacheKey.IS_PRINT_RECHARGE_BILL, value.toString())
}

export const getIsPrintCheckedBillLocalStorage = () => {
  return localStorage.getItem(CacheKey.IS_PRINT_CHECKED_BILL)
}
export const setIsPrintCheckedBillLocalStorage = (value: boolean) => {
  localStorage.setItem(CacheKey.IS_PRINT_CHECKED_BILL, value.toString())
}

/**
 * 灰度规则匹配到的最新版本
 */
export const getNewestVersion = () => {
  const strVersion = localStorage.getItem(CacheKey.NEWEST_VERSION)
  return strVersion ? JSON.parse(strVersion) as SystemVersionDTO : null
}
export const setNewestVersion = (version?: SystemVersionDTO) => {
  if (version) {
    localStorage.setItem(CacheKey.NEWEST_VERSION, JSON.stringify(version))
  } else {
    localStorage.removeItem(CacheKey.NEWEST_VERSION)
  }
}

/**
 * 上次访问的最新版本
 */
export const getLastSystemVersion: () => SystemVersionDTO | null = (): SystemVersionDTO | null => {
  const strVersion = localStorage.getItem(CacheKey.LAST_SYSTEM_VERSION)
  return strVersion ? JSON.parse(strVersion) as SystemVersionDTO : null
}
export const setLastSystemVersion = (version?: SystemVersionDTO) => {
  if (version) {
    localStorage.setItem(CacheKey.LAST_SYSTEM_VERSION, JSON.stringify(version))
  } else {
    localStorage.removeItem(CacheKey.LAST_SYSTEM_VERSION)
  }
}

/**
 * 获取需要展示更新日志的版本信息
 * @returns 需要展示的更新日志版本信息
 */
export const getUpdateNoticeNeedShow = () => {
  const strVersion = localStorage.getItem(CacheKey.UPDATE_NOTICE_NEED_SHOW)
  return strVersion ? JSON.parse(strVersion) as SystemVersionDTO : null
}
export const setUpdateNoticeNeedShow = (version?: SystemVersionDTO) => {
  if (version) {
    localStorage.setItem(CacheKey.UPDATE_NOTICE_NEED_SHOW, JSON.stringify(version))
  }
}
export const removeUpdateNoticeNeedShow = () => {
  localStorage.removeItem(CacheKey.UPDATE_NOTICE_NEED_SHOW)
}

export const getBusinessAllCategoryFlatMode = () => {
  return localStorage.getItem(CacheKey.BUSINESS_ALL_CATEGORY_FLAT_MODE) === "true"
}

export const setBusinessAllCategoryFlatMode = (value: boolean) => {
  localStorage.setItem(CacheKey.BUSINESS_ALL_CATEGORY_FLAT_MODE, value.toString())
}
